import type { Brand } from '@/api/brands/type'
import styled from '@emotion/styled'
import { Avatar, Flex, Icon, Text } from '@collable/ui'

interface ManageVideoDetailBrandInfoProps {
  brand: Brand
  onDelete: () => void
}

const ManageVideoDetailBrandInfo = ({ brand, onDelete }: ManageVideoDetailBrandInfoProps) => {
  return (
    <Container gap={10} alignItems="center">
      <Avatar size="m" type="sponsor" src={brand.logoUrl} />
      <Text size="body2" fontWeight="medium">
        {brand.brandName}
      </Text>
      <button onClick={onDelete}>
        <Icon name="xMd" iconSize={20} iconColor="labelAssistive" />
      </button>
    </Container>
  )
}

export default ManageVideoDetailBrandInfo

const Container = styled(Flex)`
  width: 320px;
  height: 48px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.line.lineNormal};
  background-color: ${({ theme }) => theme.common.commonWhite};

  button {
    height: 20px;
    margin-left: auto;
  }
`
